import { Box, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface CompanyAdminSwitchProps {
  onChange: (isAdmin: boolean) => void;
  value?: boolean;
}

export default function CompanyAdminSwitch({ onChange, value }: CompanyAdminSwitchProps): React.JSX.Element {
  const { t } = useTranslation(['company']);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Typography variant="titleSmall">
          {t('company:admin')}
        </Typography>
        <Switch
          size="large"
          checked={value}
          onClick={() => onChange(!value)}
        />
      </Box>
      <Typography variant="bodySmall" color="onSurfaceVariant">
        {t('company:admin_description')}
      </Typography>
    </Box>
  );
}
